import styles from './StakingCard.module.less';
import { Partner } from '@/types/bbsol';
import { useFm } from '@web3/base-hooks';
import Hot from '@/assets/images/bybitsol/hot.svg';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';
export const StakingCard = ({ data }: { data: Partner }) => {
  const { name, description, logoUrl, labels, desc1, desc2, desc3 } = data;
  const fm = useFm();

  const handleClick = () => {
    scTrack(Event.Web3UserClick, {
      page_name: 'StakingWeb_BBSOLhomepage',
      button_name: `Defi_stakingCard_${name}`,
    });
    window.open(data.url, '_blank');
  };

  return (
    <div className={styles.cardWrapper} onClick={handleClick}>
      <div className={styles.card__shadow} />
      <div className={styles.card}>
        <div className={styles['card__header']}>
          <div className={styles['card__header-left']}>
            <img src={logoUrl} alt={name} className={styles['card__logo']} />
            <div className={styles['card__title']}>{name}</div>
            <Hot />
          </div>
          <div className={styles['card__header-right']}>
            <div className={styles['card__apy-text']}>{desc1}</div>
            <div className={styles['card__apy-value']}>
              {desc2} {desc3}
            </div>
          </div>
        </div>

        <p className={styles['card__desc']}>{description}</p>
        <button className={styles['card__button']}>{fm('stakeNow1')}</button>
      </div>
      {labels && <div className={styles.card__label}>{labels[0]}</div>}
    </div>
  );
};
